<template>
  <Container>
    <TabMenu />
    <el-main v-loading="loading">
      <div
        v-for="item in microAppBox"
        :key="item.name"
        :id="item.container.slice(1)"
        v-show="$route.path.startsWith(item.activeRule)"
        class="layout-container"
      ></div>
      <Home v-show="$route.path === '/'"></Home>
    </el-main>
  </Container>
</template>

<script>
import { computed, defineComponent, watchPostEffect } from 'vue'
import Container from '@/components/Layout/Container.vue'
import TabMenu from '@/components/Layout/TabMenu.vue'
import Home from '@/views/Home.vue'
import { useRoute, onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'Application',
  components: {
    Container,
    Home,
    TabMenu
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const microAppBox = computed(() => {
      return store.state.microApp.microApps
    })

    const loading = computed(() => store.state.menu.menuLoading)

    watchPostEffect(() => {
      store.dispatch('microApp/setMicroApp', route.path)
      store.commit('microApp/updateMicroCacheList')
    })

    onBeforeRouteLeave(() => {
      store.dispatch('microApp/checkAppStatus')
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 400)
      })
    })

    return {
      microAppBox,
      loading
    }
  }
})
</script>

<style lang="scss" scoped>
#layout-container {
  height: 100%;
}
.el-main {
  padding: 10px;
}
</style>

<style lang="scss">
.layout-container {
  height: 100%;
  > * {
    height: 100%;
  }
}
</style>
